module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dropdown', {
    attrs: {
      "placement": "right"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('button', {
          staticClass: "rounded-full mr-3 ml-1.5 text-gray-400 hover:text-gray-800"
        }, [_c('i', {
          staticClass: "fa fa-ellipsis-v text-lg"
        })])]
      },
      proxy: true
    }, {
      key: "content",
      fn: function() {
        return [_c('ul', {
          staticClass: "w-56 font-poppins top-10 px-1.5 py-1.5"
        }, [(_vm.hasTeacherPermissionsInCourse && _vm.getCurrentDiscussion.sequence_id === null) ? _c('li', {
          staticClass: "relative"
        }, [_c('div', {
          staticClass: "flex items-center cursor-pointer hover:bg-gray-100 px-3 py-1.5 rounded",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleSubmenu.apply(null, arguments)
            }
          }
        }, [_c('i', {
          staticClass: "fa-solid text-indigo-600 fa-forward text-base"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v("Start Follow Up")]), _vm._v(" "), _c('i', {
          staticClass: "fa ml-auto",
          class: _vm.submenuOpen ? 'fa-angle-down' : 'fa-angle-right'
        })]), _vm._v(" "), (_vm.submenuOpen) ? _c('div', {
          directives: [{
            name: "click-outside",
            rawName: "v-click-outside",
            value: (_vm.closeSubmenu),
            expression: "closeSubmenu"
          }],
          staticClass: "absolute right-full top-0 mt-0 mr-1"
        }, [_c('ul', {
          staticClass: "w-32 font-poppins py-1 px-1 bg-white shadow-lg border border-solid border-gray-100 rounded-md"
        }, [_c('li', {
          staticClass: "flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleStartFollowUp('written')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center h-5 w-5 rounded-full bg-blue space-x-2.5"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/written_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Written")])]), _vm._v(" "), _c('li', {
          staticClass: "flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleStartFollowUp('verbal')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center h-5 w-5 rounded-full bg-green-light space-x-2.5"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/verbal_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Verbal")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.getCurrentDiscussion.sequence_id !== null && _vm.getCurrentDiscussion.roundtables_sequence.length < 9) ? _c('li', {
          staticClass: "relative"
        }, [_c('div', {
          staticClass: "flex items-center cursor-pointer hover:bg-gray-100 px-3 py-1.5 rounded",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleSubmenu.apply(null, arguments)
            }
          }
        }, [_c('i', {
          staticClass: "fa-solid text-indigo-600 fa-forward text-base"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v("Continue Follow Up")]), _vm._v(" "), _c('i', {
          staticClass: "fa ml-auto",
          class: _vm.submenuOpen ? 'fa-angle-down' : 'fa-angle-right'
        })]), _vm._v(" "), (_vm.submenuOpen) ? _c('div', {
          directives: [{
            name: "click-outside",
            rawName: "v-click-outside",
            value: (_vm.closeSubmenu),
            expression: "closeSubmenu"
          }],
          staticClass: "absolute right-full top-0 mt-0 mr-1"
        }, [_c('ul', {
          staticClass: "w-32 font-poppins py-1 px-1 bg-white shadow-lg border border-solid border-gray-100 rounded-md"
        }, [_c('li', {
          staticClass: "flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleStartFollowUp('written')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center h-5 w-5 rounded-full bg-blue space-x-2.5"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/written_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Written")])]), _vm._v(" "), _c('li', {
          staticClass: "flex items-center space-x-2 px-2 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleStartFollowUp('verbal')
            }
          }
        }, [_c('div', {
          staticClass: "flex items-center justify-center h-5 w-5 rounded-full bg-green-light space-x-2.5"
        }, [_c('img', {
          staticClass: "w-3 h-3",
          attrs: {
            "src": "/static/roundtable_icons/verbal_icon.svg"
          }
        })]), _vm._v(" "), _c('span', [_vm._v("Verbal")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.handleAddToUniverse()
            }
          }
        }, [_c('i', {
          staticClass: "fa-solid fa-folder-open text-sm"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v("Add to My Portfolio")])]), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.$emit('rtIntegrationAssignment', true)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sync text-base w-4"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v(" Sync Assessment ")])]), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.$emit('handleOpenExportData')
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-file-download text-base w-4"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v("Export Data")])]), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.$emit('showDuplicateModal')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-clone text-base w-4"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v(" Duplicate RoundTable ")])]), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.$emit('showEditLrtModal')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit text-base w-4"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v(" Edit Prompt ")])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.getCurrentDiscussion.sequence_id !== null) ? _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-gray-700",
          on: {
            "click": function($event) {
              return _vm.$emit('handleRemoveFromSequence')
            }
          }
        }, [_c('i', {
          staticClass: "fa-solid fa-link-slash text-base"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v("Remove from Sequence")])]) : _vm._e(), _vm._v(" "), _c('li', {
          staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-red-500",
          on: {
            "click": function($event) {
              return _vm.$emit('handleDeleteRoundTable')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-base w-4"
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-4"
        }, [_vm._v(" Delete RoundTable ")])])])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-69512012!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/liveDiscussionMenu.vue
// module id = 1747
// module chunks = 61